<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <form @submit.prevent="setOpportunityCriterias" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('pipelines.criteriasCheck') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                      fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                      fill="currentColor" />
                  </svg>
                </span>
              </div>
            </div>

            <div class="modal-body">
              <div class="col-md-12">
                  <div class="checkbox-list">
                    <CheckboxGroupInput id="criteria" :options="options" v-model="formData.criterias"/>
                  </div>
              </div>

               
            </div>
            <div class="modal-footer">
              <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
              <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>

  </template>

  <script setup>
  import { ref, defineProps, onMounted, watch } from "vue";
  import {useStore} from "vuex";
  import RequiredText from "@/components/RequiredText"
  import Button from "@/components/Button.vue"
import CheckboxGroupInput from "@/components/CheckboxGroupInput.vue";
import { computed } from "vue";

  const store = useStore()
  const props = defineProps({
   
    id: {
        type: String,
        required: true
    },
    step: {
        type: String,
        required: true
    },
    opportunity: {
        type: String,
        required: true
    },
    selected: {
      type: Array,
      default: []
    }
  })


  const emits = defineEmits(['load'])

  const formData = ref({
    opportunity_id: '',
    criterias: []
  })
  const isLoading = ref(false)

  const options = computed(() => {
    return props.selected?.map(el => ({key: el?.id, value: el?.title}))
  })

  watch(() => props.opportunity, () => {
    formData.value.opportunity_id = props.opportunity
  })

  watch(() => props.selected, () => {
    formData.value.criterias = props.selected
    .filter(item => item.checked) 
    .map(item => item.id);
  })

  function closeModal(){
    $('#'+props.id).modal('toggle')
  }

  function getChangedIds(witnessArray, selectedIds) {
    return witnessArray
          .filter(item => item.checked !== selectedIds.includes(item.id))
          .map(item => item.id); 
  }

  function setOpportunityCriterias() {
    isLoading.value = true
    let data = {
      opportunity_id: props.opportunity,
      criterias: getChangedIds(props.selected, formData.value.criterias)
    }

    if(data?.criterias?.length == 0){
      closeModal()
      isLoading.value = false
      emits('load')
      return;
    }

    store.dispatch('pipelines/changeOpportunityStateByCriterias', data)
      .then(res => {
        closeModal()
        emits('load')
        //window.toastr['success'](i18n.global.t("notification.pipeline_created"))
        
      })
      .catch((err) => {

      })
      .finally(() => isLoading.value = false)

  }

 



  onMounted(() => {

  })
  </script>

  <style scoped></style>
